

import React from 'react';
import {Button, Box, makeStyles, Theme, Card, Paper} from '@material-ui/core'
import Videocam from '@material-ui/icons/Videocam';
import VideocamOff from '@material-ui/icons/VideocamOff';
import Computer from '@material-ui/icons/Computer';
import CameraAlt from '@material-ui/icons/CameraAlt';
import Cancel from '@material-ui/icons/Cancel';
import CloudUpload from '@material-ui/icons/CloudUpload';
import {useTranslation} from 'react-i18next'
 
const useStyles= makeStyles((theme: Theme)=>({
  container:{
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%"
  },
  firstButtom:{
    marginBottom: "14px"
  },
  button:{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    paddingTop: "12px",
    paddingBottom: "12px"

  },
  icon:{
    fontSize: "26px",
    marginRight: "16px"
  },
  camera:{
    display:"flex",
    alignItems:"center",  
    flex:1,
    justifyContent:"center",
    justifyItems:"center",
    textAlign: "center"
  }

}))

export interface UploadImageButtonsProps{
  cameraRecording?: boolean
  setCameraRecording?: (cameraRecording: boolean)=>void
  onCapture?: ()=>void
  onSelectFile?: (file: File | undefined)=>void
  hasFileSelected: boolean
  onCancel?: ()=>void,
  uploadFile: ()=>void
}
const UploadImageButtons: React.FC<UploadImageButtonsProps> = ({setCameraRecording,cameraRecording, onCapture, onSelectFile, hasFileSelected, onCancel, uploadFile}) => {
  const {container, button, icon, firstButtom ,camera} = useStyles()
  const {t} = useTranslation(["FileUpload"])


  return <Box className={container} p={2} >
    {
    hasFileSelected ?
      <div>
      <Paper elevation={1} className={firstButtom}>
        <Button
          onClick={ () => onCancel()}
          className={button}>
          <Cancel className={icon}  />
          {t("cancel")}
        </Button>
      </Paper>
      <Paper elevation={1}>
        <Button 
          onClick={()=>uploadFile()}
          className={button}
          variant="contained"
          color="primary"
          
        >
          <CloudUpload  className={icon}  />
          {t("send")}
        </Button>
      </Paper>
    </div>:
    !cameraRecording?
      <div>
        <Paper elevation={1} className={firstButtom}>
          <Button 
            className={button}
            component="label"
          > 
            <input
              type="file" 
              style={{"display" : "none"}}
              accept="image/png, image/jpeg"
              onChange={(e)=>onSelectFile(e.target.files[0])}
            />
            <Computer className={icon} /> 
            {t("select_file_button")}
        </Button>
      </Paper>
      <Paper elevation={1}>
        <Button onClick={()=>setCameraRecording(true)} className={button}>
          <Videocam className={icon}  />
          {t("use_camera")}
        </Button>
      </Paper>
    </div>:
    <div>
      <Paper elevation={1} className={firstButtom}>
        <Button
          onClick={()=>setCameraRecording(false)}
          className={button}>
          <VideocamOff className={icon}  />
          {t("close_camera")}
        </Button>
      </Paper>
      <Paper elevation={1}>
        <Button 
          onClick={() => {onCapture()}}
          className={button}
        >
          <CameraAlt className={icon}  />
          {t("capture_image")}
        </Button>
      </Paper>
    </div>
    }
    
  </Box>;
}

export default UploadImageButtons;